import React, { useState } from "react";

export default function Kontakt() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

	const API_BASE =
	  window.location.hostname === "localhost"
		? "http://127.0.0.1:8000"
		: "https://geotherm-app-backend.onrender.com";

	const handleSubmit = async (e) => {
	  e.preventDefault();
	  setStatus("send");

	  try {
		const res = await fetch(`${API_BASE}/contact`, {
		  method: "POST",
		  headers: { "Content-Type": "application/json" },
		  body: JSON.stringify(formData),
		});

		if (res.ok) {
		  setStatus("success");
		  setFormData({ name: "", email: "", message: "" });
		} else {
		  setStatus("error");
		}
	  } catch (err) {
		setStatus("error");
		console.error("Kontaktformular-Fehler:", err);
	  }
	};


  return (
    <div
      style={{
        padding: "3rem 2rem",
        maxWidth: "800px",
        margin: "0 auto",
        fontFamily: "'Inter', Arial, sans-serif",
        color: "#222",
      }}
    >
      <header
        style={{
          borderBottom: "3px solid #d44",
          marginBottom: "2rem",
        }}
      >
	   <div className="pt-6" />
        <h1 style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>Kontakt</h1>
        <p style={{ color: "#666", marginBottom: "1rem" }}>
          Sie haben Fragen zu unseren Geothermie-Diensten oder möchten ein Angebot
          anfordern? Schreiben Sie uns gern eine Nachricht.
        </p>
      </header>

      <form
        onSubmit={handleSubmit}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          background: "#fafafa",
          padding: "2rem",
          borderRadius: "8px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
        }}
      >
        <label>
          Ihr Name
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            style={inputStyle}
          />
        </label>

        <label>
          Ihre E-Mail-Adresse
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            style={inputStyle}
          />
        </label>

        <label>
          Ihre Nachricht
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
            rows="6"
            style={{ ...inputStyle, resize: "vertical" }}
          ></textarea>
        </label>

        <button
          type="submit"
          style={{
            background: "#d44",
            color: "white",
            border: "none",
            padding: "0.8rem 1.5rem",
            borderRadius: "6px",
            fontSize: "1rem",
            cursor: "pointer",
            transition: "background 0.3s ease",
          }}
        >
          {status === "send"
            ? "Wird gesendet..."
            : status === "success"
            ? "Nachricht gesendet ✓"
            : "Nachricht senden"}
        </button>

        {status === "error" && (
          <p style={{ color: "red" }}>
            ❌ Beim Senden ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.
          </p>
        )}
      </form>

      <section style={{ marginTop: "2rem", fontSize: "0.9rem", color: "#555" }}>
        <p>
          Mit dem Absenden des Formulars erklären Sie sich damit einverstanden,
          dass Ihre Angaben zur Beantwortung Ihrer Anfrage verwendet werden
          (gemäß Art. 6 Abs. 1 lit. b DSGVO). Weitere Informationen finden Sie in
          unserer <a href="/datenschutz">Datenschutzerklärung</a>.
        </p>
      </section>
    </div>
  );
}

const inputStyle = {
  width: "100%",
  padding: "0.6rem",
  marginTop: "0.3rem",
  borderRadius: "6px",
  border: "1px solid #ccc",
  fontSize: "1rem",
  fontFamily: "'Inter', Arial, sans-serif",
};
